import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import ScEmergencySvc from "@/services/ScEmergencyService";

@Module({
  store,
  dynamic: true,
  namespaced: true,
  name: "sc-emergency"
})
class ScEmergencyModule extends VuexModule {
  events: any[] = [];
  currentEvent: any = null;
  indikasi: any[] = [];
  dashboard: any = null;
  rekapHarian: any[] = [];
  monthlyReport: any = null;
  monthlyEvents: any[] = [];
  loading = false;
  pagination: any = null;

  @Mutation SET_EVENTS(val: any[]) {
    this.events = val;
  }

  @Mutation SET_CURRENT_EVENT(val: any) {
    this.currentEvent = val;
  }

  @Mutation SET_INDIKASI(val: any[]) {
    this.indikasi = val;
  }

  @Mutation SET_DASHBOARD(val: any) {
    this.dashboard = val;
  }

  @Mutation SET_REKAP_HARIAN(val: any[]) {
    this.rekapHarian = val;
  }

  @Mutation SET_MONTHLY_REPORT(val: any) {
    this.monthlyReport = val;
  }

  @Mutation SET_MONTHLY_EVENTS(val: any[]) {
    this.monthlyEvents = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation SET_PAGINATION(val: any) {
    this.pagination = val;
  }

  @Action async loadIndikasi() {
    try {
      const dt = await ScEmergencySvc.getIndikasi();
      this.SET_INDIKASI(dt.data?.data || []);
    } catch {
      this.SET_INDIKASI([]);
    }
  }

  @Action async loadEvents(params?: any) {
    this.SET_LOADING(true);
    try {
      const dt = await ScEmergencySvc.getList(params);
      const resp = dt.data;
      this.SET_EVENTS(resp.data?.data || []);
      this.SET_PAGINATION({
        current_page: resp.data?.current_page,
        last_page: resp.data?.last_page,
        total: resp.data?.total,
        per_page: resp.data?.per_page,
      });
    } catch {
      this.SET_EVENTS([]);
    }
    this.SET_LOADING(false);
  }

  @Action async loadDetail(id: number) {
    this.SET_LOADING(true);
    try {
      const dt = await ScEmergencySvc.find(id);
      this.SET_CURRENT_EVENT(dt.data?.data || null);
    } catch {
      this.SET_CURRENT_EVENT(null);
    }
    this.SET_LOADING(false);
  }

  @Action async loadDashboard(params?: any) {
    this.SET_LOADING(true);
    try {
      const dt = await ScEmergencySvc.getDashboard(params);
      this.SET_DASHBOARD(dt.data?.data || null);
    } catch {
      this.SET_DASHBOARD(null);
    }
    this.SET_LOADING(false);
  }

  @Action async loadRekapHarian(params?: any) {
    this.SET_LOADING(true);
    try {
      const dt = await ScEmergencySvc.getRekapHarian(params);
      this.SET_REKAP_HARIAN(dt.data?.data || []);
    } catch {
      this.SET_REKAP_HARIAN([]);
    }
    this.SET_LOADING(false);
  }

  @Action async loadMonthly({ tahun, bulan }: { tahun: number; bulan: number }) {
    this.SET_LOADING(true);
    try {
      const dt = await ScEmergencySvc.getMonthly(tahun, bulan);
      this.SET_MONTHLY_REPORT(dt.data?.data?.report || null);
      this.SET_MONTHLY_EVENTS(dt.data?.data?.events || []);
    } catch {
      this.SET_MONTHLY_REPORT(null);
      this.SET_MONTHLY_EVENTS([]);
    }
    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_EVENTS([]);
    this.SET_CURRENT_EVENT(null);
    this.SET_DASHBOARD(null);
    this.SET_REKAP_HARIAN([]);
    this.SET_MONTHLY_REPORT(null);
    this.SET_MONTHLY_EVENTS([]);
  }
}

export const storeScEmergency = getModule(ScEmergencyModule);
